import React from "react";
import PropTypes from "prop-types";
import Link from "next/link";

const Textlink = ({
  external,
  to,
  color = "secondary",
  small,
  large,
  back,
  children,
  onClick,
  withArrows,
}) => (external ? (
  <a
    href={to || ""}
    target="_blank"
    rel="noopener noreferrer"
    className={`link link--${color} ${small ? "link--small" : ""} ${
        large ? "link--large" : ""
      } ${back ? "link--back" : ""}`}
  >
    {back && <div className="link__arrow" role="presentation" />}
    {children}
    {!back && <div className="link__arrow" role="presentation" />}
  </a>
) : (
  <Link
    href={to || ""}
    onClick={onClick}
  >
    <>
      <a
        className={`link link--${color} ${small ? "link--small" : ""} ${
        large ? "link--large" : ""
      } ${back ? "link--back" : ""}`}
        href={to || ""}
      >
        <>
          {withArrows && back && <div className="link__arrow" role="presentation" />}
          {children}
          {withArrows && !back && <div className="link__arrow" role="presentation" />}
        </>
      </a>
    </>
  </Link>
));

Textlink.defaultProps = {
  withArrows: true,
};

Textlink.propTypes = {
  external: PropTypes.bool,
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  color: PropTypes.string,
  small: PropTypes.bool,
  large: PropTypes.bool,
  back: PropTypes.bool,
  children: PropTypes.any,
  withArrows: PropTypes.bool,
};

export default Textlink;
